import { useCancelFlowMutation } from '@twisto/api-graphql'

import { useSubmittingWrapper } from './submitting-wrapper.hook'

export const useCancelFlow = (sessionId: string) => {
  const [cancelFlow] = useCancelFlowMutation()
  const submittingWrapper = useSubmittingWrapper()

  return async () =>
    submittingWrapper(
      cancelFlow({
        variables: {
          auth: {
            sessionId,
          },
        },
      })
    )
}
